

export const frontMatter = {};
export const contentTitle = 'OrbitView';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-api-reference-core-orbit-view-md-e2e.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Constructor",
  "id": "constructor",
  "level": 2
}, {
  "value": "<code>orbitAxis</code> (string, optional)",
  "id": "orbitaxis",
  "level": 4
}, {
  "value": "<code>projectionMatrix</code> (number[16], optional)",
  "id": "projectionmatrix",
  "level": 4
}, {
  "value": "<code>fovy</code> (number, optional)",
  "id": "fovy",
  "level": 4
}, {
  "value": "<code>near</code> (number, optional)",
  "id": "near",
  "level": 4
}, {
  "value": "<code>far</code> (number, optional)",
  "id": "far",
  "level": 4
}, {
  "value": "<code>orthographic</code> (boolean)",
  "id": "orthographic",
  "level": 4
}, {
  "value": "View State",
  "id": "view-state",
  "level": 2
}, {
  "value": "Controller",
  "id": "controller",
  "level": 2
}, {
  "value": "Source",
  "id": "source",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h1: "h1",
    h2: "h2",
    h4: "h4",
    header: "header",
    li: "li",
    p: "p",
    pre: "pre",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "orbitview",
        children: "OrbitView"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["The ", _jsx(_components.code, {
        children: "OrbitView"
      }), " class is a subclass of ", _jsx(_components.a, {
        href: "/docs/api-reference/core/view",
        children: "View"
      }), " that creates a 3D camera that rotates around a target position. It is usually used for the examination of a 3D scene in non-geospatial use cases."]
    }), "\n", _jsxs(_components.p, {
      children: ["It's recommended that you read the ", _jsx(_components.a, {
        href: "/docs/developer-guide/views",
        children: "Views and Projections guide"
      }), " before using this class."]
    }), "\n", _jsx("div", {
      style: {
        position: 'relative',
        height: 450
      }
    }), "\n", _jsx("div", {
      style: {
        position: 'absolute',
        transform: 'translateY(-450px)',
        paddingLeft: 'inherit',
        paddingRight: 'inherit',
        left: 0,
        right: 0
      },
      children: _jsx("iframe", {
        height: "450",
        style: {
          width: '100%'
        },
        scrolling: "no",
        title: "deck.gl OrbitView",
        src: "https://codepen.io/vis-gl/embed/gOLprOZ?height=450&theme-id=light&default-tab=result",
        frameborder: "no",
        loading: "lazy",
        allowtransparency: "true",
        allowfullscreen: "true",
        children: _jsxs(_components.p, {
          children: ["See the Pen ", _jsx("a", {
            href: "https://codepen.io/vis-gl/pen/gOLprOZ",
            children: "deck.gl OrbitView"
          }), " by vis.gl\n(", _jsx("a", {
            href: "https://codepen.io/vis-gl",
            children: "@vis-gl"
          }), ") on ", _jsx("a", {
            href: "https://codepen.io",
            children: "CodePen"
          }), "."]
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "constructor",
      children: "Constructor"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        children: "import {OrbitView} from '@deck.gl/core';\nconst view = new OrbitView({id, ...});\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "OrbitView"
      }), " takes the same parameters as the ", _jsx(_components.a, {
        href: "/docs/api-reference/core/view",
        children: "View"
      }), " superclass constructor, plus the following:"]
    }), "\n", _jsxs(_components.h4, {
      id: "orbitaxis",
      children: [_jsx(_components.code, {
        children: "orbitAxis"
      }), " (string, optional)"]
    }), "\n", _jsxs(_components.p, {
      children: ["Axis with 360 degrees rotating freedom, either ", _jsx(_components.code, {
        children: "'Y'"
      }), " or ", _jsx(_components.code, {
        children: "'Z'"
      }), ", default to ", _jsx(_components.code, {
        children: "'Z'"
      }), "."]
    }), "\n", _jsxs(_components.h4, {
      id: "projectionmatrix",
      children: [_jsx(_components.code, {
        children: "projectionMatrix"
      }), " (number[16], optional)"]
    }), "\n", _jsx(_components.p, {
      children: "Projection matrix."
    }), "\n", _jsxs(_components.p, {
      children: ["If ", _jsx(_components.code, {
        children: "projectionMatrix"
      }), " is not supplied, the ", _jsx(_components.code, {
        children: "View"
      }), " class will build a projection matrix from the following parameters:"]
    }), "\n", _jsxs(_components.h4, {
      id: "fovy",
      children: [_jsx(_components.code, {
        children: "fovy"
      }), " (number, optional)"]
    }), "\n", _jsxs(_components.p, {
      children: ["Field of view covered by camera, in the perspective case. In degrees. Default ", _jsx(_components.code, {
        children: "50"
      }), "."]
    }), "\n", _jsxs(_components.h4, {
      id: "near",
      children: [_jsx(_components.code, {
        children: "near"
      }), " (number, optional)"]
    }), "\n", _jsxs(_components.p, {
      children: ["Distance of near clipping plane. Default ", _jsx(_components.code, {
        children: "0.1"
      }), "."]
    }), "\n", _jsxs(_components.h4, {
      id: "far",
      children: [_jsx(_components.code, {
        children: "far"
      }), " (number, optional)"]
    }), "\n", _jsxs(_components.p, {
      children: ["Distance of far clipping plane. Default ", _jsx(_components.code, {
        children: "1000"
      }), "."]
    }), "\n", _jsxs(_components.h4, {
      id: "orthographic",
      children: [_jsx(_components.code, {
        children: "orthographic"
      }), " (boolean)"]
    }), "\n", _jsxs(_components.p, {
      children: ["Whether to create an orthographic or perspective projection matrix. Default is ", _jsx(_components.code, {
        children: "false"
      }), " (perspective projection)."]
    }), "\n", _jsx(_components.h2, {
      id: "view-state",
      children: "View State"
    }), "\n", _jsxs(_components.p, {
      children: ["To render, ", _jsx(_components.code, {
        children: "OrbitView"
      }), " needs to be used together with a ", _jsx(_components.code, {
        children: "viewState"
      }), " with the following parameters:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "target"
        }), " (number[3], optional) - The world position at the center of the viewport. Default ", _jsx(_components.code, {
          children: "[0, 0, 0]"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "rotationOrbit"
        }), " (number, optional) - Rotating angle around orbit axis. Default ", _jsx(_components.code, {
          children: "0"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "rotationX"
        }), " (number, optional) - Rotating angle around X axis. Default ", _jsx(_components.code, {
          children: "0"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "zoom"
        }), " (number, optional) - The zoom level of the viewport. ", _jsx(_components.code, {
          children: "zoom: 0"
        }), " maps one unit distance to one pixel on screen, and increasing ", _jsx(_components.code, {
          children: "zoom"
        }), " by ", _jsx(_components.code, {
          children: "1"
        }), " scales the same object to twice as large. Default ", _jsx(_components.code, {
          children: "0"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "minZoom"
        }), " (number, optional) - The min zoom level of the viewport. Default ", _jsx(_components.code, {
          children: "-Infinity"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "maxZoom"
        }), " (number, optional) - The max zoom level of the viewport. Default ", _jsx(_components.code, {
          children: "Infinity"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "minRotationX"
        }), " (number, optional) - The min rotating angle around X axis. Default ", _jsx(_components.code, {
          children: "-90"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "maxRotationX"
        }), " (number, optional) - The max rotating angle around X axis. Default ", _jsx(_components.code, {
          children: "90"
        }), "."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "controller",
      children: "Controller"
    }), "\n", _jsxs(_components.p, {
      children: ["By default, ", _jsx(_components.code, {
        children: "OrbitView"
      }), " uses the ", _jsx(_components.code, {
        children: "OrbitController"
      }), " to handle interactivity. To enable the controller, use:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        children: "const view = new OrbitView({id: '3d-scene', controller: true});\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Visit the ", _jsx(_components.a, {
        href: "/docs/api-reference/core/orbit-controller",
        children: "OrbitController"
      }), " documentation for a full list of supported options."]
    }), "\n", _jsx(_components.h2, {
      id: "source",
      children: "Source"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.a, {
        href: "https://github.com/visgl/deck.gl/tree/9.4-release/modules/core/src/views/orbit-view.ts",
        children: "modules/core/src/views/orbit-view.ts"
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

